import React from 'react';
import { Play, Clock, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { podcastData } from '../mock';
import Header from '../components/Header';
import Footer from '../components/Footer';

export const PodcastPage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Podcast
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Ouça discussões aprofundadas sobre os temas mais relevantes do Direito
            </p>
          </div>
        </section>

        {/* Podcast Episodes */}
        <section className="py-16 md:py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="space-y-6">
              {podcastData.map((episode) => (
                <Card key={episode.id} className="overflow-hidden hover:shadow-xl transition-shadow duration-300 border-0">
                  <CardContent className="p-6 bg-white">
                    <div className="flex flex-col md:flex-row md:items-center gap-6">
                      <div className="flex-shrink-0 w-20 h-20 bg-[#B49163] rounded-full flex items-center justify-center">
                        <Play size={32} className="text-white" />
                      </div>
                      
                      <div className="flex-grow">
                        <h3 className="text-2xl font-serif font-semibold text-[#0F172A] mb-2">
                          {episode.title}
                        </h3>
                        <p className="text-gray-600 mb-3">
                          {episode.description}
                        </p>
                        <div className="flex items-center gap-4 text-sm text-gray-500">
                          <div className="flex items-center gap-1">
                            <Clock size={16} />
                            <span>{episode.duration}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <Calendar size={16} />
                            <span>{new Date(episode.date).toLocaleDateString('pt-BR')}</span>
                          </div>
                        </div>
                      </div>
                      
                      <Button className="bg-[#0F172A] hover:bg-[#1e293b] text-white px-6 py-3 rounded-lg transition-colors duration-300">
                        Ouvir Agora
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default PodcastPage;